export default __webpack_public_path__ + "static/media/1.148fa005.jpeg";